<template>
  <ProcessingOverlay :show="true" :loadingText="loadingText" />
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { onMounted } from 'vue'
import { useAuthStore } from '@/store/auth'
import ProcessingOverlay from '@/components/ProcessingOverlay.vue'

const route = useRoute()
const router = useRouter()
const auth = useAuthStore()
const loadingText = 'ログイン処理中です。しばらくお待ちください。'

onMounted(() => {
  const token = route.params.token

  if (token) {
    auth.setToken(token)
    //localStorage.setItem('token', token)
    router.replace('/service/main-chat')
  } else {
    router.replace('/login')
  }
})
</script>
